import { FormattedMessage } from 'react-intl';
import get from 'lodash.get';

import { BannerMessageV2 } from 'ui-components/components/banner-message/banner-message-v2';
import { BannerStatus } from 'ui-components/components/banner-message/banner-enums';
import { FlexColumn, FlexRow } from 'ui-components/components/flex';
import { ModalBody } from 'ui-components/components/modal/modal-body';

import { AddressFields } from '../../../../../../address/address-fields';
import AddressOptionsSection from '../../../../fulfillment-plan/sections/shipment-details/address/edit-shipto-modal/address-options';
import PasteAddressSection from '../../../../fulfillment-plan/sections/shipment-details/address/edit-shipto-modal/paste-address-section';
import { useAddressValidatorConfig } from '../../../../../../contexts/country-config-context/use-address-validator-config';
import { useReturnConfig } from '../../../return-config-provider';

import { messages } from './messages';
import { US } from '../../../../../../constants/country-codes';
import { EMAIL, PHONE } from '../../../../../../address/constants';
import { ERR, WRN } from '../../../../../../enums/address-verification-status';
import { MULTI_LINE_EMAIL_SUB_LABEL, PHONE_NEEDED_FOR_SOME_CARRIERS } from '../../../../../../address/sublabel-constants';
import style from './styles.module.less';

export const Body = () => {
  const { formState, isValid, validationErrors, isValidatingAddress, updateForm, resetFormState, validateAddress } = useReturnConfig();
  const allowAddressValidation = useAddressValidatorConfig();

  const countryCode = get(formState, 'countryCode');
  const verificationStatus = get(formState, 'verificationStatus');
  const verificationMessage = get(formState, 'verificationMessage');

  const showPasteAddress = countryCode === US;
  const subLabels = {
    [PHONE]: PHONE_NEEDED_FOR_SOME_CARRIERS,
    [EMAIL]: MULTI_LINE_EMAIL_SUB_LABEL,
  };

  const onFieldChange = (fieldName: string, value: string) => updateForm({ [fieldName]: value });

  return (
    <ModalBody>
      {verificationStatus === WRN && <BannerMessageV2 content={verificationMessage} status={BannerStatus.Warning} />}
      {verificationStatus === ERR && (
        <BannerMessageV2
          content={<FormattedMessage {...messages.verificationBannerErrorMessage} values={{ verificationMessage }} />}
          status={BannerStatus.Error}
        />
      )}
      <FlexRow className={style['edit-address-modal-body']}>
        <FlexColumn className={style.column}>
          <AddressFields
            address={formState}
            errors={validationErrors}
            line3
            onChange={onFieldChange}
            showAllErrors
            state
            subLabels={subLabels}
            type='v3'
          />
        </FlexColumn>
        <FlexColumn className={style.column}>
          {showPasteAddress && <PasteAddressSection resetFormState={resetFormState} updateFormState={updateForm} />}
          {allowAddressValidation && (
            <AddressOptionsSection
              formState={formState}
              isValid={isValid}
              isValidatingAddress={isValidatingAddress}
              validateAddress={validateAddress}
            />
          )}
        </FlexColumn>
      </FlexRow>
    </ModalBody>
  );
};
